export default __webpack_public_path__ + "static/SR France - Biologique - Certificat-ffc545b27fc831254984a0da939e6fb5.pdf";